export enum JoinPageViews {
  NORMAL = "NORMAL",
  WAITING = "WAITING",
  MISSED_SOCIAL = "MISSED_SOCIAL",
  ARCHIVE = "ARCHIVE",
  ARCHIVE_RESTRICTED = "ARCHIVE_RESTRICTED",
}
